// ======================================================================
// File Name       : MultiLanguageAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import * as ActionTypes from '../constants/actionTypes/content';
import * as multiLanguageActionCreators from './actionCreators/multiLanguage';
import * as httpRequests from './httpRequests/multiLanguage';

export function searchMultiLanguageList(searchInfo) {
  return async (dispatch) => {
    const data = await httpRequests.postMultiLanguageGetList(searchInfo);
    return dispatch({
      type: ActionTypes.MULTI_LANGUAGE_LIST,
      data,
    });
  };
}

export function getLanguageInfo(params) {
  return async (dispatch) => {
    const resdata = await httpRequests.postLanguageInfo(params);
    return dispatch(receiveLanguageInfo(resdata));
  };
}

function receiveLanguageInfo(resdata) {
  let documentContentList = {};
  try {
    if (resdata
      && resdata.documentContentList
      && $.type(resdata.documentContentList) === 'array'
      && resdata.documentContentList.length > 0) {
      documentContentList = resdata.documentContentList[0];
    } else {
      documentContentList.noRecordFound = true;
    }
  } catch (error) {
    documentContentList.noRecordFound = true;
  }
  return {
    type: ActionTypes.MULTI_LANGUAGE_EDIT,
    documentContentList,
  };
}

export function translate(contentSecernId, languageCode) {
  return async (dispatch) => {
    try {
      const param = {
        contentSecernId,
        languageCode,
      };
      await httpRequests.postTranslate(param);
      const translateSuccess = true;
      dispatch(multiLanguageActionCreators.receiveTranslateResponse(translateSuccess));
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function editLanguageInfo(params) {
  return async (dispatch) => {
    try {
      await httpRequests.postMultiLanguageEdit(params);
      const editSuccess = true;
      dispatch(multiLanguageActionCreators.editLanguageInfo(editSuccess));
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function refreshLanguageInfo(params) {
  return async (dispatch) => {
    try {
      const resdata = await httpRequests.postLanguageInfo(params);
      dispatch(receiveLanguageInfo(resdata));
      const isRefreshData = true;
      dispatch(multiLanguageActionCreators.refreshLanguageInfo(isRefreshData));
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function receiveLanguageConfirmInfo(multiLanguageConfirmInfo) {
  return async (dispatch) => {
    dispatch(multiLanguageActionCreators.receiveLanguageConfirmInfo(multiLanguageConfirmInfo));
  };
}

export function deleteLanguageInfo(params) {
  return async (dispatch) => {
    try {
      const resdata = await httpRequests.postMultiLanguageEdit(params);
      dispatch(multiLanguageActionCreators.deleteLanguageInfo(resdata));
      return null;
    } catch (error) {
      return error;
    }
  };
}

export function resetMultiLanguageInfo() {
  return multiLanguageActionCreators.resetMultiLanguageInfo();
}

export function resetMultiLanguageStatus() {
  return multiLanguageActionCreators.resetMultiLanguageStatus();
}

export function saveMultiLanguageCode(languageCode) {
  return multiLanguageActionCreators.saveMultiLanguageCode(languageCode);
}

export function searchMultiLanguageProcessResultList(params) {
  return async (dispatch) => {
    const resdata = await httpRequests.postGetMultiLanguageProcessResultList(params);
    return dispatch(multiLanguageActionCreators.postGetMultiLanguageProcessResultList(resdata));
  };
}

export function getMultiLanguageProcessDetail(id) {
  return async (dispatch) => {
    const params = { multiLanguageProcessManagementIdAuto: parseInt(id, 10) };
    const resdata = await httpRequests.postGetMultiLanguageProcessDetail(params);
    return dispatch(multiLanguageActionCreators.postGetMultiLanguageProcessDetail(resdata));
  };
}
